var _circle, _line, _polyline, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea4426f3-9d79-40b9-bc95-884b2f610380",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-circle-download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.99991,
    cy: 21.99997,
    r: 22,
    fill: "#ededed"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.99991,
    y1: 29,
    x2: 26.99991,
    y2: 29,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "17 20 22 25 27 20",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.99991,
    y1: 13,
    x2: 21.99991,
    y2: 24,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownload);
export default __webpack_public_path__ + "static/media/circle-download.2362d0e026a8f35ee2012ce108eb1412.svg";
export { ForwardRef as ReactComponent };